/*=========================================================================================
  File Name: moduleHistory.js
  Description: Partner Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./modulePartnerState.js";
import mutations from "./modulePartnerMutations.js";
import actions from "./modulePartnerActions.js";
import getters from "./modulePartnerGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
